module.exports = __webpack_public_path__ + "img/82814bc.png";